import './bootstrap';
import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import { Inertia } from '@inertiajs/inertia'
import maska from 'maska'
import i18n from './i18n/i18n';
import { dragscrollNext } from "vue-dragscroll";
import money from 'v-money3'

import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

window.navigateTo = (url) => {
    Inertia.visit(url)
}

createInertiaApp({
    resolve: name => import(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        createApp({ render: () => h(app, props) })
            .mixin({ methods: { route } })
            .use(plugin)
            .use(i18n)
            .use(maska)
            .use(money)
            .use(PerfectScrollbar)
            .directive('dragscroll', dragscrollNext)
            .component('font-awesome-icon', FontAwesomeIcon)
            .mount(el)
    },
})

InertiaProgress.init({ color: '#ef7e8a' });

window.setViewportHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight()
window.addEventListener('resize', () => {
    setViewportHeight()
});
